var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactMailSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7711 5.2002H4.22869C3.15571 5.2002 2.28589 6.07002 2.28589 7.143V16.857C2.28589 17.93 3.15571 18.7998 4.22869 18.7998H19.7711C20.8441 18.7998 21.7139 17.93 21.7139 16.857V7.143C21.7139 6.07002 20.8441 5.2002 19.7711 5.2002Z",
    stroke: "#9393B0",
    strokeWidth: 1.4571,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84985 5.77246L10.8445 13.7574C11.0249 13.938 11.2392 14.0813 11.475 14.1791C11.7109 14.2768 11.9637 14.3272 12.219 14.3272C12.4743 14.3272 12.7271 14.2768 12.963 14.1791C13.1988 14.0813 13.4131 13.938 13.5935 13.7574L21.3647 5.98617",
    stroke: "#9393B0",
    strokeWidth: 1.4571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMailSvgrepocom);
export default __webpack_public_path__ + "static/media/contact-mail_svgrepo.com.adcb8c6a94f53eab01a4408db4f3309a.svg";
export { ForwardRef as ReactComponent };